import React from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import objectiveData from "./designBlocksData";
import ReactPlayer from "react-player";

function Objetivos() {
  const handleItemClick = (event, route) => {
    event.preventDefault();
    window.location.href = `#${route}`;
  };

  return (
    <Container>
      <Typography
        variant="h3"
        align="center"
        gutterBottom
        sx={{ fontSize: "4.5rem", color: "#348ded" }}
      >
        <br />
        <br />
        {objectiveData[0].title}
      </Typography>
      <Typography variant="body1" align="center" gutterBottom sx={{ fontSize: "1.5rem" }}>
        {objectiveData[0].description}
      </Typography>
      <Grid container spacing={4} justifyContent="center">
        {objectiveData[0].items.map((item, index) => (
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            key={index}
            container
            direction="column"
            alignItems="center"
          >
            <Box
              component="div"
              onClick={(event) => handleItemClick(event, item.route)}
              sx={{ width: "100%", display: "flex", justifyContent: "center", cursor: "pointer" }}
            >
              <img src={item.image} alt={item.name} style={{ width: "100%", height: "auto" }} />
            </Box>
            <Typography
              variant="h2"
              onClick={(event) => handleItemClick(event, item.route)}
              sx={{
                color: "#348ded",
                textDecoration: "none",
                "&:hover": {
                  textDecoration: "underline",
                },
                textAlign: "center",
                marginTop: 2,
                cursor: "pointer",
              }}
            >
              {item.name}
            </Typography>
          </Grid>
        ))}
      </Grid>
      <Typography
        variant="h2"
        align="center"
        gutterBottom
        sx={{
          marginTop: "50px",
          color: "#348ded",
          fontSize: "4.5rem",
        }}
      >
        Objetivos:
      </Typography>
      <Typography
        variant="body1"
        aling="center"
        gutterBottom
        sx={{
          fontSize: "1.85rem",
        }}
      >
        1. Conhecer a Metodologia de Ensino Modelagem Matemática
        <br />
        2. Perceber a importância da Modelagem Matemática na Educação Matemática
        <br />
        3. Compreender as Práticas de Modelagem Matemática
        <br />
        4. Vivenciar uma Prática de Modelagem Matemática
        <br />
        5. Relacionar os conteúdos matemáticos inseridos no dia a dia
        <br />
      </Typography>
      <div id="section1" style={{ marginTop: "100px" }}>
        <Typography variant="h1" align="center" gutterBottom>
          Escolha do tema
        </Typography>
        <Typography variant="body1" align="center" gutterBottom>
          Na escolha do tema, “o professor deve proporcionar um clima de liberdade para os seus
          alunos.” (BURAK, 1994, p. 51). Precisa atuar como mediador e estar ciente de que “os temas
          inicialmente podem não ter nada de matemática e, muitas vezes os estudantes não têm muita
          noção, no momento, do que querem realmente com o tema.” (BURAK, 2010a, p. 19). Dentro de
          uma mesma turma é possível a escolha de um único tema ou de vários (um tema por grupo).
        </Typography>
        <Grid item xs={12}>
          <Typography variant="h2" align="center" color="#348ded" gutterBottom>
            Etapa 1
          </Typography>
          <Box sx={{ position: "relative", paddingTop: "56.25%" }}>
            <ReactPlayer
              url="https://youtu.be/DieFPMOmRSU"
              width="100%"
              height="100%"
              style={{ position: "absolute", top: 0, left: 0 }}
              controls
            />
          </Box>
        </Grid>
      </div>
      <div id="section2" style={{ marginTop: "100px" }}>
        <Typography variant="h1" align="center" gutterBottom>
          Pesquisa Exploratória
        </Typography>
        A pesquisa exploratória tem como objetivo “conhecer mais e melhor o nosso objeto de estudo.”
        (BURAK, 2010b, p. 06). Podemos utilizar várias fontes para essa pesquisa, como a biblioteca
        da escola, entrevistas com sujeitos envolvidos com o tema, jornais, revistas e as
        ferramentas de busca da internet. Para Burak (2010b, p. 06), a pesquisa “é uma atividade
        formadora de um estudante mais atento, mais crítico e que desenvolve habilidades de elaborar
        instrumentos e meios de coletas de dados.”
        <Grid item xs={12}>
          <Typography variant="h2" align="center" color="#348ded" gutterBottom>
            Etapa 2
          </Typography>
          <Box sx={{ position: "relative", paddingTop: "56.25%" }}>
            <ReactPlayer
              url="https://youtu.be/7ecXvj6I81M"
              width="100%"
              height="100%"
              style={{ position: "absolute", top: 0, left: 0 }}
              controls
            />
          </Box>
        </Grid>
      </div>
      <div id="section3" style={{ marginTop: "100px" }}>
        <Typography variant="h1" align="center" gutterBottom>
          Levantamento dos Problemas
        </Typography>
        O levantamento dos problemas é o início da ação matemática propriamente dita, trata-se de
        uma etapa, “em que a ação e a qualidade dessa ação, por parte do aluno, se fazem notar e
        podem se constituir em diferencial educativo.” (BURAK, 2010a, p. 21). A capacidade de
        levantar e propor problemas a partir dos dados é de grande importância para o
        desenvolvimento da autonomia do estudante e, também, da sua “capacidade cidadã de traduzir e
        transformar situações do cotidiano em situações matemáticas, para quantificar uma situação e
        nas ciências sociais e humanas buscar as soluções que muitas vezes não são matemáticas, mais
        de atitudes e comportamento.” (BURAK, 2010a, p. 22).
        <Grid item xs={12}>
          <Typography variant="h2" align="center" color="#348ded" gutterBottom>
            Etapa 3
          </Typography>
          <Box sx={{ position: "relative", paddingTop: "56.25%" }}>
            <ReactPlayer
              url="https://youtu.be/nDR4Dd3SkNg"
              width="100%"
              height="100%"
              style={{ position: "absolute", top: 0, left: 0 }}
              controls
            />
          </Box>
        </Grid>
      </div>
      <div id="section4" style={{ marginTop: "100px" }}>
        <Typography variant="h1" align="center" gutterBottom>
          Resolução dos Problemas
        </Typography>
        A quarta etapa é a resolução do(s) problema(s) e o trabalho com os conteúdos matemáticos no
        contexto do tema, trata-se de um momento em que o estudante “faz uso de todo o ferramental
        matemático disponível”, esse é o momento “em que os conteúdos matemáticos ganham significado
        e importância, trabalham em um contexto e todas as ações têm sentido.” (BURAK, 2010b, p.
        07).
        <Grid item xs={12}>
          <Typography variant="h2" align="center" color="#348ded" gutterBottom>
            Etapa 4
          </Typography>
          <Box sx={{ position: "relative", paddingTop: "56.25%" }}>
            <ReactPlayer
              url="https://youtu.be/nBvNcq61tTc"
              width="100%"
              height="100%"
              style={{ position: "absolute", top: 0, left: 0 }}
              controls
            />
          </Box>
        </Grid>
      </div>
      <div id="section5" style={{ marginTop: "100px" }}>
        <Typography variant="h1" align="center" gutterBottom>
          Análise Crítica
        </Typography>
        Análise crítica da(s) solução(ções) e é um momento especial para Burak (2010b, p. 07), “pois
        se abre o espaço para as discussões, os debates sobre os resultados obtidos, à possibilidade
        de manifestações individuais na defesa de seus resultados, à reconstrução de processos.”
        Burak (2010b, p. 07) enfatiza que essa etapa “pode favorecer o desenvolvimento da autonomia,
        do pensamento lógico-matemático e da formação de um espírito crítico.”
        <Grid item xs={12}>
          <Typography variant="h2" align="center" color="#348ded" gutterBottom>
            Etapa 5
          </Typography>
          <Box sx={{ position: "relative", paddingTop: "56.25%" }}>
            <ReactPlayer
              url="https://youtu.be/6P2CLXGFWDo"
              width="100%"
              height="100%"
              style={{ position: "absolute", top: 0, left: 0 }}
              controls
            />
          </Box>
        </Grid>
      </div>
    </Container>
  );
}

export default Objetivos;
